/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CSSObject } from "styled-components";
import { FlexContainer, SVGIcon, SVGIconProps, theme } from "@nordcloud/gnui";
import { IconBox } from "./IconBox";

type IconName = SVGIconProps["name"];

type Item = {
  id: string;
  iconName: IconName;
  title: string;
  caption?: string;
};

type Props<T extends Item> = {
  items: T[];
  selected: T["id"] | null;
  onSelect: (itemId: T["id"]) => void;
  customCss?: CSSObject;
};

export function IconBoxSelector<T extends Item>({
  items,
  selected,
  onSelect,
  customCss = {},
}: Props<T>) {
  return (
    <FlexContainer
      gap={theme.spacing.spacing05}
      wrap="wrap"
      paddingTop={theme.spacing.spacing04}
      paddingBottom={theme.spacing.spacing08}
      css={[
        {
          width: "100%",
        },
        customCss,
      ]}
    >
      {items.map((item) => (
        <div
          key={item.id}
          css={{
            flex: "1 1 20%",
            maxWidth: "216px",
          }}
        >
          <IconBox
            active={selected === item.id}
            icon={<SVGIcon name={item.iconName} size="xl" />}
            label={item.title}
            caption={item.caption}
            onClick={() => onSelect(item.id)}
          />
        </div>
      ))}
    </FlexContainer>
  );
}
